"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoryHeader = void 0;
const uniqid = require("uniqid");
const imgFields = ['logo'];
const numberFields = ['position'];
class StoryHeader {
    constructor(data) {
        this.id = null;
        this.type = null;
        this.logo = 'https://med-cdn.ams3.digitaloceanspaces.com/assets/clients/medics_assets/pastille.png';
        this.title = '';
        this.subtitle = '';
        this.position = 0;
        this.isSeen = false;
        this.label = null;
        if (data) {
            data = (typeof data === 'string') ? JSON.parse(data) : data;
            this.hydrate(data);
        }
    }
    hydrate(data) {
        Object.keys(data)
            .filter(key => key in this)
            .forEach((key) => {
            var _a;
            if (imgFields.includes(key)) {
                const isSrcRotten = data[key].match(/null[?]d=/);
                this[key] = data[key] && !isSrcRotten
                    ? `${data[key].split('?d=')[0]}?d=${uniqid()}`
                    : this[key];
            }
            else if (numberFields.includes(key)) {
                this[key] = data[key] ? parseInt(data[key]) : 1;
            }
            else {
                this[key] = (_a = data[key]) !== null && _a !== void 0 ? _a : null;
            }
        });
    }
}
exports.StoryHeader = StoryHeader;
//# sourceMappingURL=StoryHeader.js.map